import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HomeSearchUiService {
  public query = signal('');

  public setQuery(value: string): void {
    this.query.set(value);
  }

  public clear(): void {
    this.query.set('');
  }
}
